function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.875 14.75H12.25C11.5596 14.75 11 14.1904 11 13.5V10.375C11 10.0298 10.7202 9.75 10.375 9.75H9.75",
  stroke: "#999999",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6875 6.625C10.5149 6.625 10.375 6.76491 10.375 6.9375C10.375 7.11009 10.5149 7.25 10.6875 7.25C10.8601 7.25 11 7.11009 11 6.9375C11 6.76491 10.8601 6.625 10.6875 6.625V6.625",
  stroke: "#999999",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 9.375,
  stroke: "#999999",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgInformationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircle);
export default __webpack_public_path__ + "static/media/information-circle.ac23aa57264299492e16d8eb1f8d53b2.svg";
export { ForwardRef as ReactComponent };